import { useEffect, useState } from 'react';
import { Card, List, Text } from '@mantine/core';
import ErrorMessage from '../ErrorMessage';

const CouponPreview = ({ file, previewList }) => {
  const linesToShow = 10;
  const [previewLines, setPreviewLines] = useState([]);
  const [error, setError] = useState();
  const [totalLines, setTotalLines] = useState(0);
  const [isFromFile, setIsFromFile] = useState(false);

  useEffect(() => {
    if (file) {
      setIsFromFile(true);
      const reader = new FileReader();

      reader.onload = (e) => {
        const text = e.target.result;
        const lines = text.split('\n').filter((line) => line.trim() !== '');
        setTotalLines(lines.length);

        if (lines.length === 0) {
          setError('The file appears to be empty. Please upload a file with coupon codes.');
          setPreviewLines([]);
          return;
        }

        const firstLines = lines.slice(0, linesToShow);
        setPreviewLines(firstLines);
        setError(undefined);
      };

      reader.onerror = () => {
        setError('Error reading file. Please try again.');
        setPreviewLines([]);
      };

      reader.readAsText(file);
    } else if (previewList && previewList.length > 0) {
      setIsFromFile(false);
      setPreviewLines(previewList.slice(0, linesToShow));
      setTotalLines(previewList.length);
      setError(undefined);
    } else {
      setPreviewLines([]);
      setTotalLines(0);
    }
  }, [file, previewList]);

  if (error) {
    return <ErrorMessage message={error} />;
  }

  if (previewLines.length === 0) {
    return;
  }

  const title = isFromFile
    ? `Preview - First ${previewLines.length} coupon code(s) from uploaded file`
    : `Sample - First ${previewLines.length} existing coupon code(s)`;

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm" withBorder>
        <strong>{title}</strong>
        {totalLines > linesToShow && <Text span c="dimmed"> (Total: {totalLines} codes)</Text>}
      </Card.Section>
      <Card.Section inheritPadding py="sm">
        <List>
          {previewLines.map((line, index) => (
            <List.Item key={index}>
              <code>{line}</code>
            </List.Item>
          ))}
        </List>
        {totalLines > linesToShow && (
          <Text c="dimmed" size="sm" mt="sm">... and {totalLines - linesToShow} more coupon code(s)</Text>
        )}
      </Card.Section>
    </Card>
  );
};

export default CouponPreview;
